import { openReactConfirmationDialog } from '~commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService, ToastType } from '~commonInfra/services/ToasterService';
import { Messages } from '~src/codegen/Localize';
import { IDeleteSmbVolumeResult } from '~src/settings/dataconnect-settings/serverApi/requests/DeleteSmbVolumeParams';
import { DomainUpdateType, IUpdateBaasEdgePoolResult } from '~src/settings/dataconnect-settings/serverApi/requests/UpdateBaasEdgePoolRequest';
import { BaasEdgePoolAndCluster } from '~src/settings/dataconnect-settings/serverApi/resources/BaasEdgePoolAndCluster';

import { ActionItemInfo } from '../../MoreActionsMenu';
import { Domain, DomainID } from '../../types/Domain';
import { DomainType } from '../../types/DomainType';
import { getGeneralErrorMessage } from '../../utils/EdgePoolErrorUtilities';

export function openDeleteDomainConfirmationDialog(deleteDomain: () => Promise<void>, domain: Domain) {
    const dialogInstance = openReactConfirmationDialog({
        title: domain.domainType === DomainType.FILESERVER ? Messages.dataConnectSiteSettingsDeleteFileServer() : Messages.dataConnectSiteSettingsDeleteDomain(),
        message: domain.domainType === DomainType.FILESERVER ? Messages.dataConnectSiteSettingsDeleteFileServerConfirmation() : Messages.dataConnectSiteSettingsDeleteDomainConfirmation(),
        paramsForAction: {},
        actionName: Messages.confirm(),
        action: () => {
          return deleteDomain();
        },
        isActionDelete: true,
        dialogWidth: TabDialogWidth.width375px
    });

    return Promise.resolve(dialogInstance.result);
}

export function openDeletePoolDomainDialog(actionItem: ActionItemInfo) {
    const deleteDomainCallback = (): Promise<void> => {
        return BaasEdgePoolAndCluster.updateBaasPool({
          poolId: actionItem.poolId,
          displayName: null,
          domainChange: { change: DomainUpdateType.Remove, domainId: actionItem.domain.domainName as DomainID },
          DataConnectSettingsVersion: '0'
        }).then((result: IUpdateBaasEdgePoolResult) => {
            if (result.success) {
              // Delete the SMB volume if the domain is a file server
              if (actionItem.domain.domainType === DomainType.FILESERVER) {
                return BaasEdgePoolAndCluster.deleteSmbVolume({
                  poolId: actionItem.poolId,
                  path: actionItem.domain.fileServerPath,
                }).then((result: IDeleteSmbVolumeResult) => {
                  if (result.success) {
                    actionItem.refreshPoolsAndClusters();
                    ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsDeleteFileServerSuccess()});
                  }
                });
              } else {
                actionItem.refreshPoolsAndClusters();
                ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsDeleteDomainSuccess() });
              }
            }
            if (result.errors) {
              ToasterService.instance.pop({
                type: ToastType.Error,
                text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
              });
            }
            return Promise.resolve();
          });
      };
      openDeleteDomainConfirmationDialog(deleteDomainCallback, actionItem.domain);
}
